import React, { useEffect, useState } from "react";
import { auth, db, storage } from "../firebaseconfig/firebase";
import { getDoc, doc, updateDoc, serverTimestamp } from "firebase/firestore";
import { Link, useNavigate } from "react-router-dom";
import { signOut } from "firebase/auth";
import { toast } from "react-toastify";
import { FaPencilAlt } from "react-icons/fa";
import { MdDelete } from "react-icons/md";
import {
  collection,
  query,
  where,
  getDocs,
  deleteDoc,
} from "firebase/firestore";
import { ref, uploadBytes, getDownloadURL } from "firebase/storage";

const Profile = () => {
  const [userDetails, setUserDetails] = useState(null);
  const [loading, setLoading] = useState(true);
  const [authUser, setAuthUser] = useState(null);
  const [myPosts, setMyPosts] = useState([]);
  const [editMode, setEditMode] = useState(false);
  const [formData, setFormData] = useState({
    firstname: "",
    lastname: "",
    userName: "",
    photoURL: "",
    email: "",
    UserDescription: "",
  });
  const [imageFile, setImageFile] = useState(null);
  const [uploading, setUploading] = useState(false);
  const [editingBio, setEditingBio] = useState(false);
  const [bioText, setBioText] = useState("");
  const [savingBio, setSavingBio] = useState(false);

  const navigate = useNavigate();

  // const handleUpdateProfile = async () => {
  //   if (!authUser) return;
  //   setUploading(true);
  //   try {
  //     let photoURL = formData.photoURL;
  //     if (imageFile) {
  //       photoURL = await uploadProfileImage();
  //     }
  //     const userRef = doc(db, "users", authUser.uid);
  //     await updateDoc(userRef, {
  //       firstname: formData.firstname.trim(),
  //       lastname: formData.lastname.trim(),
  //       userName: formData.userName.trim(),
  //       photoURL,
  //       updatedAt: serverTimestamp(),
  //     });
  //     setUserDetails((prev) => ({
  //     ...prev,
  //     ...updatedData,
  //   }));
  //     setEditMode(false);
  //     setImageFile(null);

  //   } catch (err) {
  //     console.error("Profile update failed:", err);
  //   } finally {
  //     setUploading(false);
  //   }
  // };

  const handleUpdateProfile = async () => {
    if (!authUser) return;

    setUploading(true);

    try {
      let photoURL = formData.photoURL;

      if (imageFile) {
        photoURL = await uploadProfileImage();
      }

      // ✅ DEFINE updatedData HERE
      const updatedData = {
        firstname: formData.firstname.trim(),
        lastname: formData.lastname.trim(),
        userName: formData.userName.trim(),
        photoURL,
        updatedAt: serverTimestamp(),
        UserDescription: formData.UserDescription.trim(),
      };

      const userRef = doc(db, "users", authUser.uid);
      await updateDoc(userRef, updatedData);

      // ✅ SAFE TO USE HERE
      setUserDetails((prev) => ({
        ...prev,
        ...updatedData,
      }));

      setEditMode(false);
      setImageFile(null);
    } catch (err) {
      console.error("Profile update failed:", err);
    } finally {
      setUploading(false);
    }
  };

  const handleSaveBio = async () => {
    if (!authUser) return;

    if (bioText.trim().length < 5) {
      alert("Bio must be at least 5 characters");
      return;
    }

    try {
      setSavingBio(true);

      const userRef = doc(db, "users", authUser.uid);

      await updateDoc(userRef, {
        UserDescription: bioText.trim(),
        updatedAt: serverTimestamp(),
      });

      // 🔥 Update UI instantly (NO reload)
      setUserDetails((prev) => ({
        ...prev,
        UserDescription: bioText.trim(),
      }));

      setEditingBio(false);
    } catch (err) {
      console.error("Failed to update bio:", err);
    } finally {
      setSavingBio(false);
    }
  };

  const uploadProfileImage = async () => {
    if (!imageFile || !authUser) return null;

    const imageRef = ref(storage, `avatars/${authUser.uid}`);

    await uploadBytes(imageRef, imageFile);

    const downloadURL = await getDownloadURL(imageRef);
    return downloadURL;
  };

  useEffect(() => {
    if (userDetails) {
      setFormData({
        firstname: userDetails.firstname || "",
        lastname: userDetails.lastname || "",
        userName: userDetails.userName || "",
        photoURL: userDetails.photoURL || "",
        UserDescription: userDetails.UserDescription || "",
      });
    }
  }, [userDetails]);

  
  useEffect(() => {
    if (userDetails?.UserDescription) {
      setBioText(userDetails.UserDescription);
    }
  }, [userDetails]);


  useEffect(() => {
    const unsubscribe = auth.onAuthStateChanged(async (user) => {
      console.log("AUTH USER:", user);
      setAuthUser(user);
      // if (!user) {
      //   setLoading(false);
      //   navigate("/");
      //   return;
      // }

      try {
        const docRef = doc(db, "users", user.uid);
        const docSnap = await getDoc(docRef);
        console.log("DOC SNAPSHOT:", docSnap.exists());
        if (docSnap.exists()) {
          setUserDetails(docSnap.data());
          console.log(docSnap.data());
        } else {
          console.log("User document does not exist.");
        }
      } catch (err) {
        console.error("Error loading user:", err);
      } finally {
        setLoading(false);
      }
    });

    return () => unsubscribe();
  }, [navigate]);


  useEffect(() => {
    if (!authUser) return;

    const fetchMyPosts = async () => {
      const q = query(
        collection(db, "Posts"),
        where("author.id", "==", authUser.uid)
      );

      const snapshot = await getDocs(q);
      const posts = snapshot.docs.map((doc) => ({
        id: doc.id,
        ...doc.data(),
      }));

      setMyPosts(posts);
    };

    fetchMyPosts();
  }, [authUser]);

  // LOGOUT FUNCTION
  const logout = async () => {
    try {
      await signOut(auth);
      toast.success("Logout successful!", { position: "bottom-center" });
      navigate("/");
    } catch (err) {
      toast.error(err.message, { position: "top-right" });
    }
  };
  if (loading) {
    return <p>Loading...</p>;
  }


  const deletePost = async (id) => {
    const confirmDelete = window.confirm("Delete this post?");
    if (!confirmDelete) return;
    const postdoc = doc(db, "Posts", id);
    await deleteDoc(postdoc);
    setMyPosts((prev) => prev.filter((post) => post.id !== id));
  };

  return (
    <>
      <div className="bg-blue-950 min-h-screen text-[#92A4C9] px-4 md:px-8 mt-8">
        <div className="flex flex-col lg:flex-row gap-8">
          <aside className="w-full lg:w-1/4 space-y-6">
            <div className="bg-[#192233] p-6 rounded-lg text-center">
              <img
                className="w-24 h-24 mx-auto rounded-full object-cover"
                src={userDetails?.photoURL}
                alt="user"
              />

              <h2 className="text-white text-xl font-semibold mt-4">
                {userDetails?.firstname} {userDetails?.lastname}
              </h2>

              <p className="text-sm text-gray-400">
                @{userDetails?.firstname}
                {userDetails?.lastname}
              </p>

              <p className="text-sm mt-4 leading-relaxed">
                {userDetails?.UserDescription ||
                  "Welcome to your profile. Here you can manage your posts, update your profile, and track your activity."}
              </p>
                  <button
                        onClick={() => setEditingBio(true)}
                        className="mt-2 text-blue-400 hover:underline"
                      >
                        Edit Bio
                      </button>


              <button
                onClick={() => setEditMode(true)}
                className="mt-6 bg-blue-600 hover:bg-blue-700 transition text-white px-4 py-2 rounded w-full"
              >
                Edit Profile
              </button>
            </div>

            {editMode && (
              <div className="mt-6 space-y-4">
                <input
                  type="text"
                  placeholder="First name"
                  value={formData.firstname}
                  onChange={(e) =>
                    setFormData({ ...formData, firstname: e.target.value })
                  }
                  className="w-full p-2 rounded bg-[#0f172a] text-white"
                />

                <input
                  type="text"
                  placeholder="Last name"
                  value={formData.lastname}
                  onChange={(e) =>
                    setFormData({ ...formData, lastname: e.target.value })
                  }
                  className="w-full p-2 rounded bg-[#0f172a] text-white"
                />

                {/* <input
                  type="text"
                  placeholder="User Details"
                  value={formData.UserDescription}
                  onChange={(e) =>
                    setFormData({ ...formData, UserDescription: e.target.value })
                  }
                  className="w-full p-2 rounded bg-[#0f172a] text-white"
                /> */}

                <div className="mt-4 text-sm text-gray-400">
                  {!editingBio ? (
                    <>
                      <p>
                        {userDetails?.UserDescription ||
                          "Welcome to your profile. Here you can manage your posts, update your profile, and track your activity."}
                      </p>

                      <button
                        onClick={() => setEditingBio(true)}
                        className="mt-2 text-blue-400 hover:underline"
                      >
                        Edit Bio
                      </button>
                    </>
                  ) : (
                    <>
                      <textarea
                        value={bioText}
                        onChange={(e) => setBioText(e.target.value)}
                        rows={4}
                        maxLength={300}
                        className="w-full bg-[#0f172a] border border-gray-600 rounded p-2 text-white"
                        placeholder="Write something about yourself..."
                      />

                      <div className="flex gap-4 mt-2">
                        <button
                          onClick={handleSaveBio}
                          disabled={savingBio}
                          className="bg-blue-600 px-4 py-1 rounded text-white disabled:opacity-50"
                        >
                          {savingBio ? "Saving..." : "Save"}
                        </button>

                        <button
                          onClick={() => {
                            setBioText(userDetails?.UserDescription || "");
                            setEditingBio(false);
                          }}
                          className="text-gray-400 hover:underline"
                        >
                          Cancel
                        </button>
                      </div>
                    </>
                  )}
                </div>

                <input
                  type="text"
                  placeholder="Username"
                  value={formData.userName}
                  onChange={(e) =>
                    setFormData({ ...formData, userName: e.target.value })
                  }
                  className="w-full p-2 rounded bg-[#0f172a] text-white"
                />

                <label className="cursor-pointer flex flex-col items-center gap-2">
                  <img
                    src={formData.photoURL}
                    alt="profile"
                    className="w-24 h-24 rounded-full object-cover border"
                  />

                  <span className="text-sm text-blue-400 hover:underline">
                    Change Photo
                  </span>

                  <input
                    type="file"
                    accept="image/*"
                    hidden
                    onChange={(e) => setImageFile(e.target.files[0])}
                  />

                  <button
                    disabled={uploading}
                    className="bg-green-600 text-white px-4 py-2 rounded w-full"
                  >
                    {uploading ? "Saving..." : "Save Changes"}
                  </button>
                </label>

                <div className="flex gap-4">
                  <button
                    onClick={handleUpdateProfile}
                    disabled={loading}
                    className="bg-green-600 text-white px-4 py-2 rounded flex-1"
                  >
                    {loading ? "Saving..." : "Save"}
                  </button>

                  <button
                    onClick={() => setEditMode(false)}
                    className="bg-gray-600 text-white px-4 py-2 rounded flex-1"
                  >
                    Cancel
                  </button>
                </div>
              </div>
            )}

            <div className="bg-[#192233] p-6 rounded-lg space-y-4">
              <div className="border-b border-gray-600 pb-2">
                <p className="text-sm">Member Since</p>
                <h4 className="text-white font-medium">
                  {authUser?.metadata?.creationTime &&
                    new Date(authUser.metadata.creationTime).toDateString()}
                </h4>
              </div>

              <div>
                <h2 className="text-xl font-bold">{myPosts.length}</h2>
                <p className="text-sm">Total Posts</p>
              </div>
            </div>
          </aside>

          <main className="w-full lg:w-3/4 bg-[#192233] rounded-lg p-6">
            <h2 className="text-white text-2xl font-semibold border-b border-gray-600 pb-3 mb-6">
              Your Posts
            </h2>

            {myPosts.length === 0 ? (
              <p className="text-gray-400">
                You haven’t created any posts yet.
              </p>
            ) : (
              myPosts.map((post) => (
                <div
                  key={post.id}
                  className="flex flex-col md:flex-row xl:flex-row gap-8 items-center border-b border-gray-700 pb-8 mb-8"
                >
                  <div className="w-full xl:w-1/2 space-y-4">
                    <p className="text-sm">
                      Published on <span className="text-gray-400">  </span>
                    </p>

                    <h2 className="text-white text-xl md:text-2xl font-bold">
                      <Link
                        className=" text-white"
                        to={`/blogdescription/${post.id}`}
                      >
                        {post.title}
                      </Link>
                    </h2>

                    <p className="text-sm md:text-base">
                      {post.postDescription?.substring(0, 350)}....
                    </p>

                    <div className="flex gap-6 pt-2">
                      {/* <button
                        type="button"
                        className="flex items-center gap-4 text-blue-400 hover:text-blue-500"
                      >
                        <Link className="flex gap-2" to={`/post/${post.id}`}>
                          <FaPencilAlt /> Edit
                        </Link>
                      </button> */}

                      <button
                        type="button"
                        onClick={() => deletePost(post.id)}
                        className="flex items-center gap-2 text-red-400 hover:text-red-500"
                      >
                        <MdDelete /> Delete
                      </button>
                    </div>
                  </div>

                  <div className="w-full xl:w-1/2">
                    <img
                      className="w-full max-h-[380px] object-cover rounded-lg"
                      src={post?.thumbnail}
                      alt="post"
                    />
                  </div>
                </div>
              ))
            )}
          </main>
        </div>
      </div>
    </>
  );
};

export default Profile;
